import { Grid, Typography } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import { setActivoSeccionesAction } from '../../secciones/SeccionesAction';
import SelectFieldSeccionesComponent from '../../secciones/components/SelectFieldSecciones';
import { PARAMS_BOLETINES } from '../BoletinesReducer';

const FiltrosBoletinesComponent = () => {
  const dispatch = Redux.useDispatch();

  const boletinesStore = Redux.useSelector((state) => state.boletines);
  const seccionesStore = Redux.useSelector((state) => state.secciones);

  const getData = async (object) => {
    const payload = { ...boletinesStore.params, ...object };
    dispatch({ type: PARAMS_BOLETINES, payload });
  };

  return (
    <Grid container spacing={2}>
      <Grid item md={12}>
        <Typography variant="h6" color="initial">
          FILTROS
        </Typography>
      </Grid>

      <Grid item md={12}>
        <SelectFieldSeccionesComponent
          value={boletinesStore.params.idSeccion}
          isEmpty={false}
          isAll={false}
          onChange={(idSeccion) => {
            const seccion = seccionesStore.all.find(
              (el) => el.id === idSeccion,
            );
            setActivoSeccionesAction(dispatch, seccion);
            getData({ idSeccion });
          }}
        />
      </Grid>
    </Grid>
  );
};

export default FiltrosBoletinesComponent;
